var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.keys),function(k,i){return _c('span',{key:i,staticClass:"caption"},[_c('span',{class:((_vm.regdata[k]?'success--text':'warning--text') + " mr-1")},[_vm._v(_vm._s(k.toUpperCase()))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }